import { requireSupabase } from "../lib/supabase";

const client = () => requireSupabase();
const toProductScope = (scope) => (scope === "organization" ? "club" : scope);
const clientBrandText = (value) => typeof value === "string"
  ? value.replace(/soccer[\s_-]*analytics[\s_-]*client/gi, "Soccertycs Client")
  : value;
export const isVisiblePlan = (plan) =>
  !String(plan?.plan_key || "").startsWith("performance-")
  && !(
    plan?.scope === "individual"
    && (plan?.compatible_professional_roles || []).includes("fitness_coach")
  );

export const isSubscriptionAccessActive = (subscription, now = Date.now()) => {
  if (subscription?.status === "active") return true;
  if (subscription?.status !== "trialing") return false;
  const periodEnd = Date.parse(subscription.current_period_end || "");
  return Number.isFinite(periodEnd) && periodEnd > now;
};

export async function getPlanCatalog() {
  const { data, error } = await client().rpc("get_public_plan_catalog");
  if (error) throw error;
  return (data || [])
    .filter(isVisiblePlan)
    .map((plan) => ({
      ...plan,
      scope: toProductScope(plan.scope),
      display_name: clientBrandText(plan.display_name),
      description: clientBrandText(plan.description),
      features: Array.isArray(plan.features) ? plan.features.map(clientBrandText) : plan.features,
    }));
}

export async function getMySubscriptions() {
  const { data, error } = await client()
    .from("subscriptions")
    .select(
      "id, scope, subscriber_id, plan_key, status, current_period_end, cancel_at_period_end, seats_total, stripe_customer_id, created_at, updated_at"
    )
    .order("updated_at", { ascending: false });
  if (error) throw error;
  return (data || []).map((subscription) => ({ ...subscription, scope: toProductScope(subscription.scope) }));
}

export async function getAdminSubscriptions() {
  const { data, error } = await client().rpc("admin_list_subscriptions");
  if (error) throw error;
  return data || [];
}
